import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useGetDatasetInfo } from "../../../api/api-hooks/apiHooks";
import "./style.scss";
import { copyToClipBoard } from "./utils";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";

const DatasetInfoByID = () => {
  const [displayModal, setDisplayModal] = useState(false);
  const [id, setId] = useState<string | null>(null);
  const [idNumber, setIdNumber] = useState<number | undefined>();
  const [selectedType, setSelectedType] = useState<string>("REMOTE_CATEGORIZED_DATASET");
  const typesOfDataset: Array<string> = ["CATEGORIZED_DATASET", "REMOTE_CATEGORIZED_DATASET"];
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const { data, isLoading, isSuccess, isFetching } = useGetDatasetInfo(id, { enabled: !!id });

  useEffect(() => {
    const fullID: string = `${idNumber?.toString()}:${selectedType}`;
    if (displayModal && idNumber != null) {
      setId(fullID);
    }
  }, [idNumber, selectedType]);

  const onClick = () => {
    setDisplayModal(true);
  };

  const onHide = () => {
    setDisplayModal(false);
    setId(null);
    setIsCopied(false);
    setIdNumber(undefined);
  };

  const onCopy = () => {
    if (isSuccess && data?.title != undefined) {
      copyToClipBoard(data.title as string);
      setIsCopied(true);
    }
  };

  const renderFooter = () => {
    return (
      <div className="mt-4">
        <Button label="Close" icon="pi pi-times" onClick={() => onHide()} className="p-button-danger p-button-rounded" />
        <Button
          label={isCopied ? "Copied!" : "Copy"}
          icon="pi pi-copy"
          onClick={() => onCopy()}
          autoFocus
          className="p-button-success p-button-rounded"
          disabled={!isSuccess || isLoading || data?.title === null}
        />
      </div>
    );
  };

  const GridRow = (props: any) => {
    return (
      <div className="grid">
        <div className="col-3">
          <p>{props?.name}:</p>
        </div>
        <div className="col-9">
          <p className={props?.style}>{props?.value}</p>
        </div>
      </div>
    );
  };

  const TagSpan = (props: any) => {
    return <span className="flex-inline font-semibold bg-primary border-round-md mr-2 mt-1 mb-1 p-1"> {props.tag}</span>;
  };

  const Tags = (props: any) => {
    return (
      <div className="grid">
        <div className="col-3">
          <p>{props?.name}:</p>
        </div>
        <div className="col-9 w-min">
          {props.tags.map((t: string) => (
            <TagSpan tag={t} key={t} />
          ))}
        </div>
      </div>
    );
  };

  const DatasetInfo = () => {
    return (
      <>
        {isSuccess && data?.identifier != null && (
          <div className="mr-4 mt-4">
            <GridRow name="ID" value={data?.identifier} />
            <GridRow name="Title" value={data?.title} style="font-semibold" />
            <GridRow name="Unit" value={data?.unit} />
            <GridRow name="Data Type" value={data?.dataType} />
            <GridRow name="Data Access Type" value={data?.accessType} />
            <GridRow name="Decimal places" value={data?.decimalPlaces} />
            <GridRow name="Group id" value={data?.groupId} />
            <GridRow name="Group title" value={data?.groupTitle} />
            <GridRow name="Category id" value={data?.categoryId} />
            <GridRow name="Category title" value={data?.categoryTitle} />
            <GridRow name="Dataset class" value={data?.datasetClass} />
            <Tags name="Tags" tags={data?.tags} />
          </div>
        )}
        {isLoading || (isFetching && <p className="font-semibold text-sm mt-2">searching...</p>)}
        {(!isSuccess && idNumber !== undefined) || (data?.identifier === null && <p className="font-semibold text-red-500 text-sm mt-2">not found</p>)}
      </>
    );
  };

  const DatasetIDSearchField = () => {
    return (
      <div className="fullWidth h-min flexRow align-items-center">
        <div className="w-min h-min">
          <label htmlFor="datasetId">Search by dataset ID:</label>
          <InputNumber id="datasetId" className="mt-2" value={idNumber} onValueChange={(e) => setIdNumber(e.value as number)} min={0} autoFocus />
        </div>
        <p className="font-semibold text-2xl mt-6 mb-4 ml-3 mr-3">:</p>
        <div className="w-full h-min">
          <label htmlFor="datasetType">Select dataset class:</label>
          <Dropdown
            id="datasetType"
            className="w-full mt-2"
            value={selectedType}
            options={typesOfDataset}
            onChange={(e) => setSelectedType(e.value)}
            editable
          />
        </div>
      </div>
    );
  };

  return (
    <div>
      <Button className="p-button-secondary p-button-rounded p-button-text" icon="pi pi-search" onClick={() => onClick()} />
      <Dialog header="Dataset information by ID" visible={displayModal} style={{ width: "40vw" }} footer={renderFooter()} onHide={() => onHide()}>
        <DatasetIDSearchField />
        <DatasetInfo />
      </Dialog>
    </div>
  );
};

export default DatasetInfoByID;
